import { render } from "./NoticeToast.vue?vue&type=template&id=3e85c410"
import script from "./NoticeToast.vue?vue&type=script&lang=js"
export * from "./NoticeToast.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__